import React, { useEffect, useState } from 'react';

function PanelInfoLayer({ infoLayer, setInfoLayer, cambio }) {
    const [fadeClass, setFadeClass] = useState('');

    useEffect(() => {
        setFadeClass('fadeIn');
        const timer = setTimeout(() => setFadeClass(''), 500);
        return () => clearTimeout(timer);
    }, [cambio]);

    function cerrarPanel(){
        setInfoLayer({...infoLayer, visible: false});
    }

    return(
        <div style={{ display: infoLayer.visible ? 'block' : 'none' }} className={`panelAviso panelCentrado panelInfoLayerOrVisor ${fadeClass}`}>
            <div className="panelLayerOrVisorEncabezado">
                <div>
                    {infoLayer.nombre}
                </div>
                <button className="botonCerrar" onClick={cerrarPanel}>✖</button>
            </div>
            <div className="listaDetalleLayerOrVisor">
                {
                    infoLayer.items.map((infoLayerItem, index) => 
                        <div key={index} className="itemListaDetalleLayerOrVisor">
                            <span className="labelItemListaDetalleLayerOrVisor">{infoLayerItem.label}</span>
                            <span className="valorItemListaDetalleLayerOrVisor">{infoLayerItem.valor}</span>
                        </div>
                    )
                }
            </div>
        </div>
    ); 
}

export default PanelInfoLayer;